import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pt-tick-cross',
  templateUrl: 'tick-cross.component.html'
})
export class TickCrossComponent implements OnInit {
  @Input() value: boolean;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/_foundation/components/tick-cross/tick-cross.component.ts